<template>
    <div class="d-flex flex-row flex-wrap">
      <span v-for="answerer in getAnswerers()" :key="answerer.nick_name"><PlayerName :answerer="answerer" :highlight="highlight(answerer)"/></span>
    </div>
</template>

<script>

import PlayerName from "@/components/rps/PlayerName.vue";

const sortby = require("lodash.sortby");

export default {
  components: { PlayerName },
  props: ["selectedCaseNumber", "selectedCaseChoice", "selectedPlayer", "reporting", "sortPlayerNames"],
  data: function () {
    return {};
  },
  computed: {
  },
  methods: {
    highlight(answerer) {
      if (this.selectedPlayer === 0) {
        // Team report
        return false;
      }

      if (this.selectedPlayer) {
        const selectedPlayer = this.$store.getters.getPlayerById(this.selectedPlayer);
        
        if (selectedPlayer.nick_name === answerer.nick_name) {
          return true; 
        } else {
          return false;
        }
      }

      if (this.$store.state.main.thisPlayerId && this.$store.getters.getThisPlayer.nick_name === answerer.nick_name) {
        return true;
      } else {
        return false;
      }
    },
    getAnswerers() {
      const answers = this.$store.getters.getRPSAnswersForRPSCaseChoice(this.selectedCaseChoice.rps_case_choice)

      const answerers = [];

      for (let i = 0; i < answers.length; i++) {
        const playerId = answers[i].player;
        const player = this.$store.getters.getPlayerById(playerId);

        const game = this.$store.getters.getGameReportingGamesById(player.game);

        let color = null;

        if (game) {
          color = this.$store.getters.getReportingColorByGameCode(game.game_code);
        }

        // If only one player is selected, then only push her/him.
        let name = null;
        if (this.$store.state.main.game.anonymizeRPSReport && !this.selectedPlayer && this.$store.state.main.thisPlayerId !== playerId && this.reporting) {
          name = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
        } else {
          name = player.nick_name;
        }

        answerers.push({ nick_name: name, color: color })
      }

      if (this.sortPlayerNames) {
        return sortby(answerers, [function(o) { return o.nick_name; }]);
      } else {
        // These have been sorted already in combination report
        return answerers;
      }
    }
  },
};
</script>
